<template>
  <div>
    <!-- 手机模型 -->
    <div :class="['phone-box',isPreview?'active':'']">
      <div class="stereo"></div>
      <div class="text">
        <!-- 内容 txt-->
        <div class="content" :style="styleObj" v-html="html"></div>
      </div>
      <div class="circle"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
      return {
        preview: "预 览"
      };
    },
    props: ['html', 'isPreview','styleObj'],
    methods: {}
};
</script>
<style lang="scss" scoped>
.phone-box {
  background-color: rgba($color: #333333, $alpha: 0.9);
  height: 667px;
  width: 375px;
  position: fixed;
  right: -385px;
  top: 85px;
  z-index: 999;
  border-radius: 20px;
  box-shadow: 0 0 5px #666;
  transition: all 0.6s;
  overflow: hidden;
  .stereo {
    width: 40px;
    height: 10px;
    background-color: rgba(51, 51, 51, 0.6);
    border: 1px solid #fff;
    border-radius: 15px;
    margin: 20px auto 0;
  }
  .text {
    background-color: #e8e8e8;
    overflow-y: auto;
    color: #333333;
    position: absolute;
    top: 55px;
    left: 15px;
    right: 15px;
    bottom: 55px;
    .header {
      background: linear-gradient(#1d1c21, #3c3c3c);
      padding: 30px 10px;
      display: flex;
      align-items: center;
      color: #ffffff;
      .left {
        font-size: 14px;
        color: #feca05;
        span {
          font-size: 24px;
        }
      }
      .center {
        border-left: 1px solid #666;
        padding-left: 8px;
        margin-left: 8px;
        font-size: 14px;
        span {
          font-size: 18px;
          font-weight: normal;
        }
      }
      .right {
        width: 50px;
        height: 50px;
        background-color: #dddddd;
        border-radius: 50%;
        overflow: hidden;
        flex: none;
        margin-left: auto;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .tab {
      margin: -20px 10px auto;
      display: flex;
      font-size: 14px;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 3px 1px 1px #cccccc;
      padding: 10px 0;
      .tab-head {
        flex: 1;
        text-align: center;
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}

.content {
  font-size: 14px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 3px 1px 1px #cccccc;
  padding: 10px;
  margin: 15px 10px;
}

.phone-box.active {
  right: 20px;
}

.circle {
  position: absolute;
  bottom: 8px;
  transform: translateX(-50%);
  left: 50%;
  width: 40px;
  height: 40px;
  background-color: #dddddd;
  box-shadow: 0 0 5px #333333;
  border-radius: 50%;
}
</style>
<style lang="scss">
  .phone-box .content{
    img{
      max-width: 100%;
    }
  }
</style>